import { language, locales } from "./constants";
/**
 * @param {string} timeString  - E.g "8:20","00:00", "17:40", "5:23"
 * @returns {number} - converted number E.g 820, 0, 1740, 523
 */
export const toMilitaryTime = (timeString) => {
    let time;

    if (typeof timeString === "string" && timeString.length >= 4) {
        const timeStringCopy = timeString.trim();
        time =  parseInt(timeStringCopy.slice(0,5).replace(':', ''));
    }

    return time;
}

/**
 * @param {string} ISODate  - E.g "2024-05-07T19:06:28.647Z"
 * @param {boolean} hours  - want to display hour?
 * @returns {formattedDate} - "DD/MM/YYYY" or "MM/DD/YYYY"
 */
export const getFormattedDate = (ISODate, hours = false) => {
    const currentLanguage = localStorage.getItem("lang");

    const locale = currentLanguage === language.es ? locales.es : locales.en;
    const date = new Date(ISODate);
    
    if (isNaN(date.getTime())) return ISODate;

    const dateParams = {
        day:'2-digit',
        month: '2-digit',
        year:'numeric'
    };

    if (hours) {
        dateParams.hour = '2-digit';
        dateParams.minute = '2-digit';
        dateParams.second = '2-digit';
    }

    return new Intl.DateTimeFormat(locale, dateParams).format(date);
}


export const normalizeString = (string) => {
    let normalizedString = string ;
    normalizedString = normalizedString.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    normalizedString = normalizedString.replace(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
    normalizedString = normalizedString.replace(/\s/gi, ' ');
    return normalizedString;
}

export const validateBody = (data) => {
  if (data) {
    if (data.hasOwnProperty('ops')) {
      if ((data.ops.length == 1 && data.ops[0].insert === "\n") || data.ops.length === 0) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  }
  return false;
}
